import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const RejectedRec16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_433)'>
      <path
        d='M7.43935 6.49994L5.43934 4.49993L6.5 3.43927L8.50001 5.43928L10.5 3.43928L11.5607 4.49994L9.56067 6.49994L11.5607 8.49993L10.5 9.56059L8.50001 7.5606L6.50001 9.5606L5.43935 8.49994L7.43935 6.49994Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 1.49994C0.25 0.809584 0.809643 0.249939 1.5 0.249939H14.5C15.1904 0.249939 15.75 0.809584 15.75 1.49994V11.4999C15.75 12.1903 15.1904 12.7499 14.5 12.7499H7.81066L5.38391 15.1767C4.59646 15.9642 3.25003 15.4065 3.25003 14.2928V12.75L1.49998 12.7499C0.809633 12.7499 0.25 12.1903 0.25 11.4999V1.49994ZM1.75 1.74994V11.2499L4.75003 11.25V13.6893L7.18934 11.2499H14.25V1.74994H1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_433'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

RejectedRec16.displayName = 'RejectedRec16';
export default RejectedRec16;
